module.exports = __webpack_public_path__ + "img/quick.b307e4db.png";